'use strict';

angular.module('far.modals.message-popup', [])
.controller('MessagePopupController', function($uibModalInstance, messages, title) {
	var vm = {
		close: function() {
			$uibModalInstance.close();
		}
	};

	if (!title && messages.length == 1) {
		vm.message = messages[0];
	} else {
		vm.title = title;
		vm.messages = messages;
	}

	return vm;
});